import './SuccessToast.scss';

const SuccessToast = ({textArray}) => (
    <div className="success-toast">
        {textArray.map(text => (<p key={`text-${text.split(' ').join('')}`}>{text}</p>))}
    </div>
);

export default SuccessToast;
